module.exports = __webpack_public_path__ + "static/media/ico-library.e6308339.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ico-library.svg
// module id = 737
// module chunks = 0